export const SET_USERS = 'SET_USERS';
export const SET_USERS_START = 'SET_USERS_START';
export const SET_USERS_FAILED = 'SET_USERS_FAILED';
export const SAVE_EDITED_STORE_START = 'SAVE_EDITED_STORE_START';
export const SAVE_EDITED_STORE_SUCCESS = 'SAVE_EDITED_STORE_SUCCESS';
export const SAVE_EDITED_STORE_FAILED = 'SAVE_EDITED_STORE_FAILED';
export const GET_STORES_START = 'GET_STORES_START';
export const GET_STORES_SUCCESS = 'GET_STORES_SUCCESS';
export const GET_STORES_FAILED = 'GET_STORES_FAILED';
export const ADD_USER_STORE_START = 'ADD_USER_STORE_START';
export const ADD_USER_STORE_SUCCESS = 'ADD_USER_STORE_SUCCESS';
export const ADD_USER_STORE_FAILED = 'ADD_USER_STORE_FAILED';
export const DELETE_USER_STORE_START = 'DELETE_USER_STORE_START';
export const DELETE_USER_STORE_SUCCESS = 'DELETE_USER_STORE_SUCCESS';
export const DELETE_USER_STORE_FAILED = 'DELETE_USER_STORE_FAILED';
export const DELETE_USER_START = 'DELETE_USER_START';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED';
export const DELETE_STORE_START = 'DELETE_STORE_START';
export const DELETE_STORE_SUCCESS = 'DELETE_STORE_SUCCESS';
export const DELETE_STORE_FAILED = 'DELETE_STORE_FAILED';
export const ADD_STORE_START = 'ADD_STORE_START';
export const ADD_STORE_SUCCESS = 'ADD_STORE_SUCCESS';
export const ADD_STORE_FAILED = 'ADD_STORE_FAILED';
export const GET_CATALOG_STORE_CODES_START = 'GET_CATALOG_STORE_CODES_START';
export const GET_CATALOG_STORE_CODES_SUCCESS = 'GET_CATALOG_STORE_CODES_SUCCESS';
export const GET_CATALOG_STORE_CODES_FAILED = 'GET_CATALOG_STORE_CODES_FAILED';

export const GET_ALL_PERMISSION_CONFIGS_START = 'GET_ALL_PERMISSION_CONFIGS_START';
export const GET_ALL_PERMISSION_CONFIGS_SUCCESS = 'GET_ALL_PERMISSION_CONFIGS_SUCCESS';
export const GET_ALL_PERMISSION_CONFIGS_FAILED = 'GET_ALL_PERMISSION_CONFIGS_FAILED';
export const CREATE_PERMISSION_CONFIG_START = 'CREATE_PERMISSION_CONFIG_START';
export const CREATE_PERMISSION_CONFIG_SUCCESS = 'CREATE_PERMISSION_CONFIG_SUCCESS';
export const CREATE_PERMISSION_CONFIG_FAILED = 'CREATE_PERMISSION_CONFIG_FAILED';
export const UPDATE_PERMISSION_CONFIG_START = 'UPDATE_PERMISSION_CONFIG_START';
export const UPDATE_PERMISSION_CONFIG_SUCCESS = 'UPDATE_PERMISSION_CONFIG_SUCCESS';
export const UPDATE_PERMISSION_CONFIG_FAILED = 'UPDATE_PERMISSION_CONFIG_FAILED';
export const DELETE_PERMISSION_CONFIG_START = 'DELETE_PERMISSION_CONFIG_START';
export const DELETE_PERMISSION_CONFIG_SUCCESS = 'DELETE_PERMISSION_CONFIG_SUCCESS';
export const DELETE_PERMISSION_CONFIG_FAILED = 'DELETE_PERMISSION_CONFIG_FAILED';

export const CREATE_SM_USER_START = 'CREATE_SM_USER_START';
export const CREATE_SM_USER_SUCCESS = 'CREATE_SM_USER_SUCCESS';
export const CREATE_SM_USER_FAILED = 'CREATE_SM_USER_FAILED';

export const GET_SUBSCRIPTION_COUPON_CODES_START = 'GET_SUBSCRIPTION_COUPON_CODES_START';
export const GET_SUBSCRIPTION_COUPON_CODES_SUCCESS = 'GET_SUBSCRIPTION_COUPON_CODES_SUCCESS';
export const GET_SUBSCRIPTION_COUPON_CODES_FAILED = 'GET_SUBSCRIPTION_COUPON_CODES_FAILED';

export const CREATE_SUBSCRIPTION_COUPON_CODE_START = 'CREATE_SUBSCRIPTION_COUPON_CODE_START';
export const CREATE_SUBSCRIPTION_COUPON_CODE_SUCCESS = 'CREATE_SUBSCRIPTION_COUPON_CODE_SUCCESS';
export const CREATE_SUBSCRIPTION_COUPON_CODE_FAILED = 'CREATE_SUBSCRIPTION_COUPON_CODE_FAILED';

export const UPDATE_SUBSCRIPTION_COUPON_CODE_START = 'UPDATE_SUBSCRIPTION_COUPON_CODE_START';
export const UPDATE_SUBSCRIPTION_COUPON_CODE_SUCCESS = 'UPDATE_SUBSCRIPTION_COUPON_CODE_SUCCESS';
export const UPDATE_SUBSCRIPTION_COUPON_CODE_FAILED = 'UPDATE_SUBSCRIPTION_COUPON_CODE_FAILED';

export const DELETE_SUBSCRIPTION_COUPON_CODE_START = 'DELETE_SUBSCRIPTION_COUPON_CODE_START';
export const DELETE_SUBSCRIPTION_COUPON_CODE_SUCCESS = 'DELETE_SUBSCRIPTION_COUPON_CODE_SUCCESS';
export const DELETE_SUBSCRIPTION_COUPON_CODE_FAILED = 'DELETE_SUBSCRIPTION_COUPON_CODE_FAILED';

export const GET_STORE_TYPE_START = 'GET_STORE_TYPE_START';
export const GET_STORE_TYPE_SUCCESS = 'GET_STORE_TYPE_SUCCESS';
export const GET_STORE_TYPE_FAILED = 'GET_STORE_TYPE_FAILED';

export const GET_SM_REPORT_EXPORT_START = 'GET_SM_REPORT_EXPORT_START';
export const GET_SM_REPORT_EXPORT_SUCCESS = 'GET_SM_REPORT_EXPORT_SUCCESS';
export const GET_SM_REPORT_EXPORT_FAILED = 'GET_SM_REPORT_EXPORT_FAILED';

export const GET_TOUCHMD_UPLOADS_START = 'GET_TOUCHMD_UPLOADS_START';
export const GET_TOUCHMD_UPLOADS_SUCCESS = 'GET_TOUCHMD_UPLOADS_SUCCESS';
export const GET_TOUCHMD_UPLOADS_FAILED = 'GET_TOUCHMD_UPLOADS_FAILED';

export const GET_USERS_EXPORT_START = 'GET_USERS_EXPORT_START';
export const GET_USERS_EXPORT_SUCCESS = 'GET_USERS_EXPORT_SUCCESS';
export const GET_USERS_EXPORT_FAILED = 'GET_USERS_EXPORT_FAILED';

export const setUsers = (data, autocomplete) => ({
  type: SET_USERS,
  data,
  autocomplete
});

export const setUsersStart = () => ({
  type: SET_USERS_START
});

export const setUsersFailed = (error) => ({
  type: SET_USERS_FAILED,
  error
});


export const getUsersExportStart = () => ({
  type: GET_USERS_EXPORT_START
});

export const getUsersExportSuccess = () => ({
  type: GET_USERS_EXPORT_SUCCESS,
});

export const getUsersExportFailed = (error) => ({
  type: GET_USERS_EXPORT_FAILED,
  error
});

export const getStoresStart = () => ({
  type: GET_STORES_START
});

export const getStoresSuccess = (data) => ({
  type: GET_STORES_SUCCESS,
  data
});

export const getStoresFailed = (error) => ({
  type: GET_STORES_FAILED,
  error
});

export const addUserStoreStart = () => ({
  type: ADD_USER_STORE_START
});

export const addUserStoreSuccess = (data) => ({
  type: ADD_USER_STORE_SUCCESS,
  data
});

export const addUserStoreFailed = (error) => ({
  type: ADD_USER_STORE_FAILED,
  error
});

export const deleteUserStoreStart = () => ({
  type: DELETE_USER_STORE_START
});

export const deleteUserStoreSuccess = (data) => ({
  type: DELETE_USER_STORE_SUCCESS,
  data
});

export const deleteUserStoreFailed = (error) => ({
  type: DELETE_USER_STORE_FAILED,
  error
});

export const deleteUserStart = () => ({
  type: DELETE_USER_START
});

export const deleteUserSuccess = (data) => ({
  type: DELETE_USER_SUCCESS,
  data
});

export const deleteUserFailed = (error) => ({
  type: DELETE_USER_FAILED,
  error
});

export const deleteStoreStart = () => ({
  type: DELETE_STORE_START
});

export const deleteStoreSuccess = (id, data) => ({
  type: DELETE_STORE_SUCCESS,
  id,
  data
});

export const deleteStoreFailed = (error) => ({
  type: DELETE_STORE_FAILED,
  error
});

export const saveEditedStoreStart = () => ({
  type: SAVE_EDITED_STORE_START
});

export const saveEditedStoreSuccess = (data) => ({
  type: SAVE_EDITED_STORE_SUCCESS,
  data
});


export const saveEditedStoreFailed = (error) => ({
  type: SAVE_EDITED_STORE_FAILED,
  error
});


export const addStoreStart = () => ({
  type: ADD_STORE_START
});

export const addStoreSuccess = (store, data) => ({
  type: ADD_STORE_SUCCESS,
  store,
  data
});

export const addStoreFailed = (error) => ({
  type: ADD_STORE_FAILED,
  error
});

export const getAllPermissionConfigsStart = () => ({
  type: GET_ALL_PERMISSION_CONFIGS_START
});

export const getAllPermissionConfigsSuccess = ({ configs }) => ({
  type: GET_ALL_PERMISSION_CONFIGS_SUCCESS,
  configs
});

export const getAllPermissionConfigsFailed = (error) => ({
  type: GET_ALL_PERMISSION_CONFIGS_FAILED,
  error
});

export const createPermissionConfigStart = () => ({
  type: CREATE_PERMISSION_CONFIG_START
});

export const createPermissionConfigSuccess = (data) => ({
  type: CREATE_PERMISSION_CONFIG_SUCCESS,
  data
});

export const createPermissionConfigFailed = (error) => ({
  type: CREATE_PERMISSION_CONFIG_FAILED,
  error
});

export const updatePermissionConfigStart = () => ({
  type: UPDATE_PERMISSION_CONFIG_START
});

export const updatePermissionConfigSuccess = (data) => ({
  type: UPDATE_PERMISSION_CONFIG_SUCCESS,
  data
});

export const updatePermissionConfigFailed = (error) => ({
  type: UPDATE_PERMISSION_CONFIG_FAILED,
  error
});

export const deletePermissionConfigStart = () => ({
  type: DELETE_PERMISSION_CONFIG_START
});

export const deletePermissionConfigSuccess = (id, data) => ({
  type: DELETE_PERMISSION_CONFIG_SUCCESS,
  data,
  id
});

export const deletePermissionConfigFailed = (error) => ({
  type: DELETE_PERMISSION_CONFIG_FAILED,
  error
});

export const getCatalogStoreCodesStart = () => ({
  type: GET_CATALOG_STORE_CODES_START
});

export const getCatalogStoreCodesSuccess = (data) => ({
  type: GET_CATALOG_STORE_CODES_SUCCESS,
  data
});

export const getCatalogStoreCodesFailed = (error) => ({
  type: GET_CATALOG_STORE_CODES_FAILED,
  error
});

export const createSMUserStart = () => ({
  type: CREATE_SM_USER_START
});
export const createSMUserSuccess = (data) => ({
  type: CREATE_SM_USER_SUCCESS,
  data
});
export const createSMUserFailed = (error) => ({
  type: CREATE_SM_USER_FAILED,
  error
});

export const getSubscriptionCouponCodesStart = () => ({
  type: GET_SUBSCRIPTION_COUPON_CODES_START
});

export const getSubscriptionCouponCodesSuccess = (data) => ({
  type: GET_SUBSCRIPTION_COUPON_CODES_SUCCESS,
  data
});

export const getSubscriptionCouponCodesFailed = (error) => ({
  type: GET_SUBSCRIPTION_COUPON_CODES_FAILED,
  error
});

export const createSubscriptionCouponCodeStart = () => ({
  type: CREATE_SUBSCRIPTION_COUPON_CODE_START
});

export const createSubscriptionCouponCodeSuccess = (data) => ({
  type: CREATE_SUBSCRIPTION_COUPON_CODE_SUCCESS,
  data
});

export const createSubscriptionCouponCodeFailed = (error) => ({
  type: CREATE_SUBSCRIPTION_COUPON_CODE_FAILED,
  error
});


export const updateSubscriptionCouponCodeStart = () => ({
  type: UPDATE_SUBSCRIPTION_COUPON_CODE_START
});

export const updateSubscriptionCouponCodeSuccess = (data) => ({
  type: UPDATE_SUBSCRIPTION_COUPON_CODE_SUCCESS,
  data
});

export const updateSubscriptionCouponCodeFailed = (error) => ({
  type: UPDATE_SUBSCRIPTION_COUPON_CODE_FAILED,
  error
});

export const deleteSubscriptionCouponCodeStart = () => ({
  type: DELETE_SUBSCRIPTION_COUPON_CODE_START
});

export const deleteSubscriptionCouponCodeSuccess = (id) => ({
  type: DELETE_SUBSCRIPTION_COUPON_CODE_SUCCESS,
  id
});

export const deleteSubscriptionCouponCodeFailed = (error) => ({
  type: DELETE_SUBSCRIPTION_COUPON_CODE_FAILED,
  error
});

export const getStoreTypeStart = () => ({
  type: GET_STORE_TYPE_START
});

export const getStoreTypeSuccess = (data) => ({
  type: GET_STORE_TYPE_SUCCESS,
  data
});

export const getStoreTypeFailed = (error) => ({
  type: GET_STORE_TYPE_FAILED,
  error
});

export const getSMReportExportStart = () => ({
  type: GET_SM_REPORT_EXPORT_START
});

export const getSMReportExportSuccess = (data) => ({
  type: GET_SM_REPORT_EXPORT_SUCCESS,
  data
});

export const getSMReportExportFailed = (error) => ({
  type: GET_SM_REPORT_EXPORT_FAILED,
  error
});

export const getTouchMdUploadsStart = () => ({
  type: GET_TOUCHMD_UPLOADS_START
});

export const getTouchMdUploadsSuccess = (data) => ({
  type: GET_TOUCHMD_UPLOADS_SUCCESS,
  data
});

export const getTouchMdUploadsFailed = (error) => ({
  type: GET_TOUCHMD_UPLOADS_FAILED,
  error
});
